var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullet-selector"},[_c('BaseAutocomplete',{attrs:{"options":_vm.bullets,"placeholder":"Select ammo","initVal":_vm.initVal},on:{"optionSelected":_vm.setBullet,"optionDeselected":_vm.clear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }